<div class="modal-size" role="dialog">
  <gstar-header-modal [id]="modalId">
    <span>{{ title() | translate }}</span>
  </gstar-header-modal>
  <gstar-body-modal>
    <p>
      {{ description() | translate }}
    </p>
  </gstar-body-modal>
</div>
